import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getDriver, getMatrixDriver, getTicketDriver, patchUpdateDriver } from 'redux/actions/UserDriver';
import { getMatrixVehicle, getMoreVehicle, getVehicle } from 'redux/actions/UserVehicle';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import { editDriverDialogData } from './DriverViewData';
import ProfileVendor from 'pages/vendor/profileVendor/ProfileVendor';
import TabDriverVendor from 'pages/vendor/driverVendor/TabDriverVendor';
import { vehicleInfo as generateVehicleInfo } from 'pages/vendor/driverVendor/ViewDriverVendorData';
import { amenitiesVehicle as aminitiesVehicleInfo } from 'pages/vendor/driverVendor/ViewDriverVendorData';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';

function DriverView() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {state} = useLocation();
  const id = state?.driverId;
  const profileId = state?.id;
  const name = state?.name;
  const tabType = state?.tabType;
  const role = localStorage.getItem('role');
  const [value, setValue] = useState('matrix');
  const driverData = useSelector((state) => state?.userDriver?.userDriver?.data?.body[0])
  const matrixData = useSelector((state) => state?.userMatrixDriver?.userMatrixDriver?.data)
  const ticketData = useSelector((state) => state?.userTicketDriver?.userTicketDriver?.data)
  const moreDetailsData = useSelector((state) => state?.userMoreVehicle?.userMoreVehicle?.data)
  const vehicleInfoData = useSelector((state) => state?.userVehicle?.userVehicle?.data);
  const vehicleMoreData = useSelector((state) => state?.userMoreVehicle?.userMoreVehicle?.data);
  const vehicleMatrixData = useSelector((state) => state?.userMatrixVehicle?.userMatrixVehicle?.data);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [defaultValue, setDefaultValue] = useState({});
  const [iconId, setIconId] = useState(null);
  const tabDetails = {
    matrixData: matrixData,
    ticketData: ticketData,
    moreDetailsData: moreDetailsData,
    vehicleData: vehicleInfoData
  }
  const loaderdriver = useSelector((state) => state?.userDriver?.loading)

  const filterData = {
    driverId: id,
    status: "",
    page: "",
    pageSize: "",
    date: '',
    duration: '',
    type: 'driver'
  }

  const vehicleInfotable = generateVehicleInfo(vehicleInfoData);
  const vehicleInfoaminities = aminitiesVehicleInfo(vehicleInfoData);
  const driverVehicleId = driverData?.Vehicle?.id

  const refreshDriverData = () => {
  dispatch(getDriver(filterData));
  dispatch(getMoreVehicle(driverFilterData));
};

  const vehicleData = {
    vehicleId: driverVehicleId,
    type: "driver"
  }

  const vehicleComplianceData = {
    submitterId: driverVehicleId,
    submitterType: "vehicle"
  }

  const driverFilterData = {
    submitterId: id,
    submitterType: "driverProfile"
  }

  const vehicleMatrix = {
    vehicleId: driverVehicleId,
  }

  useEffect(() => {
    dispatch(getDriver(filterData));
    dispatch(getMatrixDriver(filterData));
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const onEditProfile = (data, code) => {
    const profileData = {
      driverId: id,
      data: {
        "firstName": data?.vendorName,
        "lastName": "",
        "email": data?.email,
        "countryCode": "+91",
        "mobile": data?.number,
        "companyName": "",
        "location": data?.address,
      }
    }
    dispatch(patchUpdateDriver(profileData));
  }

  const handleChange = (val) => {
    setValue(val)
    if (val === 'ticket') {
      dispatch(getTicketDriver(filterData));
    } else if (val === 'moreDetails') {
      dispatch(getMoreVehicle(driverFilterData))
    } else if (val === 'Vehicle') {
      dispatch(getVehicle(vehicleData));
      dispatch(getMoreVehicle(vehicleComplianceData));
      dispatch(getMatrixVehicle(vehicleMatrix));
    } else {
      dispatch(getMatrixDriver(filterData));
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const onClickTableVendor = (val) => {
    const url = window.location.pathname.split('/')[2];
    if (url === 'details') {
      if (value === 'Vehicle') {
        navigate(
          '/driver/vehicle', {state:{vehicleId:val?.id, status:val?.status, name:val?.carModel}}
        );
      }
    }
  };

  const breadcrumbPaths = [
    { name: 'Driver', url: '/driver', className: 'colorGrey fontSemi' },
    { name: name, url: '', className: 'colorBlue' },
  ];

  //for subheader actions
  const onClickStatusIcon = (data) => {
    setDefaultValue(value);
    setIconId(data.id);
    let profileData = {}
   if (data === 'Deactivate') {
      profileData = {
        driverId: id,
        data: {
          status: 'InActive',
        },
      };
    } else if (data === 'Activate') {
      profileData = {
        driverId: id,
        data: {
          status: 'Active',
        },
      };
    }
    else if (data === 'Block') {
      profileData = {
        driverId: id,
        data: {
          status: 'Blocked',
        },
      };
    }
    else if (data === 'Unblock') {
      profileData = {
        driverId: id,
        data: {
          status: 'Active',
        },
      };
    }
    dispatch(patchUpdateDriver(profileData));
  };

  //roles and permissions 
const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
const subVendorRoleEnum = roleAndPermissionEnum.subvendor
const cityManagerRoleEnum = roleAndPermissionEnum.citymanager
const driverRoleEnum = roleAndPermissionEnum.driver

const accessCityManagerForAdd = handlePermissions(roleAndPermissions, cityManagerRoleEnum.moduleKey, {defaultAllAccess: cityManagerRoleEnum.all, customAccess: cityManagerRoleEnum.add});

const accessForAdd = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {defaultAllAccess: subVendorRoleEnum.all, customAccess: subVendorRoleEnum.add});

const accessForDriverAll = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {defaultAllAccess: driverRoleEnum.all, customAccess: driverRoleEnum.add});

const editAccess = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.edit});

const accessForSubVendorDriverActivate = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.activateDriver});

const accessForSubVendorDriverBlock = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.blockDriver});

const accessForDriverBlock = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.driverBlock});

const accessForDriverActivate = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.driverActivate});

const editButton = (accessCityManagerForAdd ||accessForAdd || accessForDriverAll|| editAccess)

const statusChange = (accessCityManagerForAdd ||accessForAdd || accessForDriverAll||accessForDriverBlock || accessForDriverActivate||accessForSubVendorDriverActivate|| accessForSubVendorDriverBlock )

  return (
    <div>
      {(tabType === 'dashboard' && role === 'adminCompany') ? null : <CommonBreadCrumb paths={breadcrumbPaths} />}
      <ProfileVendor
        type={'Driver'}
        editData={editDriverDialogData(driverData)}
        onSubmittBtn={onEditProfile}
        details={driverData}
        onClickStatusIcon={onClickStatusIcon}
        loader={loaderdriver}
        editButton={!editButton}
        statusChange={statusChange}
         />
      <TabDriverVendor
        details={driverData}
        handleChange={handleChange}
        value={value}
        tabDetails={tabDetails}
        onClickTableVendor={onClickTableVendor}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        vehicleInfo={vehicleInfotable}
        amenitiesVehicle={vehicleInfoaminities}
        driverVehicleId={driverVehicleId}
        vehicleMatrixData={vehicleMatrixData}
        vehicleMoreData={vehicleMoreData}
        editButton={editButton}
        refreshDriverData={refreshDriverData}
      />
    </div>
  )
}

export default DriverView